import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/index.css";

const msalInstance = new PublicClientApplication(msalConfig);

// IMPORTANT: initialize MSAL first
msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then(() => {

    const root = ReactDOM.createRoot(document.getElementById("root"));

    root.render(
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    );

  });
});